var advideo = require('./lib/advideo');

module.exports = advideo;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.ad.mobile/app/index.js